export function isBelgianPharmaCustomer() {
    const ds = window.drupalSettings;
    return !!(ds && ds.ef2_custom && ds.ef2_custom.belgian_pharma_customer);
}

export function getDisplayedArticleNumber(item) {
    if (isBelgianPharmaCustomer() && item && item.cnk_code) {
        return item.cnk_code;
    }
    return item ? item.sku : '';
}

export function getArticleNumberLabel(item) {
    const showingCnk = isBelgianPharmaCustomer() && item && item.cnk_code;
    return showingCnk
        ? window.Drupal.t('CNK Code')
        : window.Drupal.t('article number');
}

export default {
    methods: {
        isBelgianPharmaCustomer,
        getArticleNumberLabel,
        getDisplayedArticleNumber,
    }
}


